var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 16.0146V20.5035C14 20.7796 14.2141 21.0037 14.4792 21.0037H19.5243C19.7884 21.0037 20.0025 20.7796 20.0025 20.5035V15.9876",
    stroke: "#4EAEA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.6689L17.0837 14.0008L21.0033 16.6689",
    stroke: "#4EAEA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4547 12.8673C11.8266 12.8673 12.9388 11.7552 12.9388 10.3833C12.9388 9.01137 11.8266 7.89923 10.4547 7.89923C9.08284 7.89923 7.9707 9.01137 7.9707 10.3833C7.9707 11.7552 9.08284 12.8673 10.4547 12.8673Z",
    stroke: "#4EAEA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8913 10.9235C18.0214 8.86166 17.3051 6.75678 15.7294 5.18113C12.8162 2.26791 8.09422 2.26791 5.181 5.18113C2.26779 8.09434 2.26779 12.8163 5.181 15.7295L10.4552 21.0037",
    stroke: "#4EAEA5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.c69c3aae.svg";
export { ForwardRef as ReactComponent };